export var constructorReducer = {
    setFile: function (state, action) {
        state.file = action.payload;
    },
    setInfo: function (state, action) {
        state.reportInfo = action.payload;
    },
    setAboutBuilding: function (state, action) {
        //state.data = action.payload;
    },
    setCreateConstructionData: function (state, action) {
        state.createConstructionData = action.payload;
    },
    setConstructionSheets: function (state, action) {
        state.constructionsSheet = action.payload;
    },
    setInfoFull: function (state, action) {
        state.reportInfoFull = action.payload;
    },
};
